import { render, staticRenderFns } from "./SubunidadesCargadas.vue?vue&type=template&id=eea591e6&"
import script from "./SubunidadesCargadas.vue?vue&type=script&lang=js&"
export * from "./SubunidadesCargadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports